<template>
  <div class="page block">
    <div class="page__wrapper block-wrapper">
      <div class="page__header">
        <div class="page__title">
          <Title>{{$t($route.meta.title)}}</Title>
        </div>
      </div>
      <div class="page__body">
        <ClientInfo :key="clientKey"/>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '@/components/titles/Title'
import ClientInfo from '@/components/client-info/ClientInfo'
import ClientController from './client-controller'

import {VIEWS} from '@/views/names'

export default {
  name: VIEWS.client.name,
  mixins: [ClientController],
  components: {
    Title,
    ClientInfo
  }
}
</script>
